import dayjs from "dayjs";
import { Component, OnInit, signal, inject, input } from "@angular/core";
import { AppConfigService } from "../../../../core-ui/services/app.config.service";
import { formatTimezone } from "../../../../core-ui/services/utils";
import {
  IAppointment,
  IAppointmentRouting,
} from "../../../../core-ui/models/Appointment";
@Component({
  selector: "av-appointment-calendar",
  templateUrl: "./appointment-calendar.component.html",
  styleUrls: ["./appointment-calendar.component.scss"],
  standalone: false,
})
export class AppointmentCalendarComponent implements OnInit {
  private config = inject(AppConfigService);

  readonly appointment = input<IAppointment<IAppointmentRouting>>(undefined);

  timezoneOffset = signal<string>(null);
  lang = signal<string>(undefined);

  constructor() {
    this.lang.set(this.config.language);
  }

  ngOnInit(): void {
    this.timezoneOffset.set(
      formatTimezone(
        dayjs.tz(this.appointment().start, this.appointment().timezone)
      )
    );
  }
}
